import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Layout from "../Components/Layout/Layout";
import { setIsAuthenticated } from "../slices/authSlice";
import { isUserAuthenticated } from "../utils/aws";

export const ProtectedRoute = ({
  redirectPath = "/signin",
  children,
  Component,
}) => {
  console.log("🚀 ~ Component:", !!localStorage.getItem("accessToken"))

  // const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  // useEffect(() => {
  //   isUserAuthenticated()
  //     .then((authStatus) => {
  //       dispatch(setIsAuthenticated(authStatus));
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       dispatch(setIsAuthenticated(false));
  //     });
  // }, []);

  // if (!localStorage.getItem("accessToken")) {
  //   // Optionally, render a loading spinner or similar here
  //   return (
  //     <div className="fixed top-0 left-0 w-screen h-screen bg-gray-200 flex justify-center items-center">
  //       <LoadingOutlined style={{ fontSize: 35, color: "#E4342D" }} />
  //     </div>
  //   );
  // }
console.log(isAuthenticated, "=isAuthenticatedisAuthenticated");

  if (isAuthenticated) {
    return (
      <Layout>
        {/* <div className="min-h-screen flex flex-col"> */}
        <Component />
        {/* </div> */}
      </Layout>
    );
  } else {
    // return (
    // <div>
    //   <Layout>
    //     <Component />
    //   </Layout>
    // </div>
    // );
    return <Navigate to={redirectPath} replace={true} />;
  }
};
